import React, { forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';

// eslint-disable-next-line prefer-arrow-callback
const InsightsCardBox = forwardRef(function InsightsCardBox({
  headerLeft,
  headerRight,
  children,
  bodyMinHeight,
  className,
  id,
}, ref) {
  return (
    <div
      ref={ref}
      className={cx('card-box', className)}
      id={id}
    >
      <header className="card-box__head">
        <div className="card-box__head-left">
          {headerLeft}
        </div>
        {headerRight && (
          <div className="card-box__head-right">
            {headerRight}
          </div>
        )}
      </header>
      <div className="card-box__body" style={{ minHeight: bodyMinHeight }}>
        {children}
      </div>
    </div>
  );
});

InsightsCardBox.propTypes = {
  headerLeft: T.node.isRequired,
  headerRight: T.node,
  children: T.node.isRequired,
  bodyMinHeight: T.oneOfType([T.string, T.number]),
  className: T.string,
  id: T.string,
};

export default InsightsCardBox;
